<template>
  <div v-if="show" class="calc-overlay" @click.self="close">
    <div class="calc-container">
      <div class="calc-header">
        <span class="calc-title">计算器</span>
        <span class="calc-close" @click="close">×</span>
      </div>
      <div class="calc-display">
        <div class="calc-expression">{{ expression || '0' }}</div>
        <div class="calc-result">{{ result }}</div>
      </div>
      <div class="calc-buttons">
        <div class="calc-row">
          <button class="calc-btn calc-btn-clear" @click="clear">C</button>
          <button class="calc-btn calc-btn-clear" @click="clearEntry">CE</button>
          <button class="calc-btn calc-btn-clear" @click="backspace">←</button>
          <button class="calc-btn calc-btn-operator" @click="appendOperator('/')">÷</button>
        </div>
        <div class="calc-row">
          <button class="calc-btn calc-btn-number" @click="appendNumber('7')">7</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('8')">8</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('9')">9</button>
          <button class="calc-btn calc-btn-operator" @click="appendOperator('*')">×</button>
        </div>
        <div class="calc-row">
          <button class="calc-btn calc-btn-number" @click="appendNumber('4')">4</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('5')">5</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('6')">6</button>
          <button class="calc-btn calc-btn-operator" @click="appendOperator('-')">−</button>
        </div>
        <div class="calc-row">
          <button class="calc-btn calc-btn-number" @click="appendNumber('1')">1</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('2')">2</button>
          <button class="calc-btn calc-btn-number" @click="appendNumber('3')">3</button>
          <button class="calc-btn calc-btn-operator" @click="appendOperator('+')">+</button>
        </div>
        <div class="calc-row">
          <button class="calc-btn calc-btn-number" @click="appendNumber('0')">0</button>
          <button class="calc-btn calc-btn-number" @click="appendDecimal">.</button>
          <button class="calc-btn calc-btn-operator" @click="toggleSign">±</button>
          <button class="calc-btn calc-btn-equals" @click="calculate">=</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calculator',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expression: '',
      result: '',
      lastResult: '',
      waitingForOperand: false
    };
  },
  methods: {
    close() {
      this.clear();
      this.$emit('close');
    },
    clear() {
      this.expression = '';
      this.result = '';
      this.lastResult = '';
      this.waitingForOperand = false;
    },
    clearEntry() {
      if (this.waitingForOperand || !this.expression) {
        this.clear();
        return;
      }
      
      let parts = this.expression.split(/([+\-*/])/);
      if (parts.length > 0) {
        parts.pop();
        this.expression = parts.join('');
      }
    },
    backspace() {
      this.expression = this.expression.slice(0, -1);
    },
    appendNumber(num) {
      if (this.waitingForOperand) {
        this.expression = '';
        this.waitingForOperand = false;
      }
      this.expression += num;
    },
    appendDecimal() {
      if (this.waitingForOperand) {
        this.expression = '0.';
        this.waitingForOperand = false;
        return;
      }
      let lastOperatorIndex = Math.max(
        this.expression.lastIndexOf('+'),
        this.expression.lastIndexOf('-'),
        this.expression.lastIndexOf('*'),
        this.expression.lastIndexOf('/')
      );
      
      let lastNumber = this.expression.substring(lastOperatorIndex + 1);
      if (!lastNumber.includes('.')) {
        this.expression += '.';
      }
    },
    appendOperator(op) {
      if (this.waitingForOperand) {
        this.expression = this.lastResult;
        this.waitingForOperand = false;
      }
      
      let lastChar = this.expression.slice(-1);
      if (['+', '-', '*', '/'].includes(lastChar)) {
        this.expression = this.expression.slice(0, -1) + op;
      } else if (this.expression) {
        this.expression += op;
      }
    },
    toggleSign() {
      if (this.expression) {
        let lastOperatorIndex = Math.max(
          this.expression.lastIndexOf('+'),
          this.expression.lastIndexOf('-'),
          this.expression.lastIndexOf('*'),
          this.expression.lastIndexOf('/')
        );
        
        let lastNumber = this.expression.substring(lastOperatorIndex + 1);
        let beforeNumber = this.expression.substring(0, lastOperatorIndex + 1);
        
        if (lastNumber.startsWith('-')) {
          lastNumber = lastNumber.substring(1);
        } else if (lastNumber) {
          lastNumber = '-' + lastNumber;
        }
        
        this.expression = beforeNumber + lastNumber;
      }
    },
    calculate() {
      if (!this.expression) return;
      
      try {
        let evalExpression = this.expression
          .replace(/×/g, '*')
          .replace(/÷/g, '/')
          .replace(/−/g, '-');
        
        let calculated = Function('"use strict"; return (' + evalExpression + ')')();
        this.result = String(calculated);
        this.lastResult = this.result;
        this.waitingForOperand = true;
      } catch (error) {
        this.result = '错误';
      }
    }
  }
};
</script>

<style scoped>
.calc-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.calc-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 370px;
  overflow: hidden;
}


.calc-header {
  background: linear-gradient(to bottom, #52a0ff, #3c8dff);
  color: white;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.calc-title {
  font-size: 18px;
  font-weight: bold;
}

.calc-close {
  font-size: 28px;
  cursor: pointer;
  line-height: 1;
  cursor: pointer;
}

.calc-display {
  background: #f5f5f5;
  padding: 16px;
  text-align: right;
}

.calc-expression {
  font-size: 20px;
  color: #666;
  min-height: 24px;
  margin-bottom: 8px;
  word-break: break-all;
}

.calc-result {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  min-height: 36px;
}

.calc-buttons {
  padding: 8px;
}

.calc-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.calc-row:last-child {
  margin-bottom: 0;
}

.calc-btn {
  flex: 1;
  height: 60px;
  font-size: 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.calc-btn:active {
  transform: scale(0.98);
}

.calc-btn-number {
  background: #f0f0f0;
  color: #333;
}

.calc-btn-number:hover {
  background: #e0e0e0;
}

.calc-btn-operator {
  background: #ff9500;
  color: white;
}

.calc-btn-operator:hover {
  background: #e68600;
}

.calc-btn-clear {
  background: #e0e0e0;
  color: #333;
}

.calc-btn-clear:hover {
  background: #d0d0d0;
}

.calc-btn-equals {
  background: #4cd964;
  color: white;
}

.calc-btn-equals:hover {
  background: #44c859;
}
</style>
